import { connect } from 'react-redux'
import { logout } from '../actions'
import MyAppBar from '../components/MyAppBar'
import { withRouter } from 'react-router'

const mapStateToProps = (state) => {
	return{}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logout: () => {
			dispatch(logout())
		}
 	}
}

const MyAppBarContainer = connect(
	mapStateToProps, mapDispatchToProps
)(MyAppBar)

export default withRouter(MyAppBarContainer)


// WEBPACK FOOTER //
// ./src/containers/MyAppBarContainer.js